import { useRef } from 'react';
import { Input, Tooltip } from 'antd';
import { Controller } from 'react-hook-form';
import { TextAreaProps } from 'antd/lib/input';
import HelpInfo from './HelpInfo';
import InfoCircleIcon from '../Icons/InfoCircleIcon';
import { useTranslation } from 'react-i18next';
import { useHover } from 'hooks';
import validateInput from 'utils/validation';
const { TextArea } = Input;

interface Props extends TextAreaProps {
  control: any;
  inputName: string;
  placeholder?: string;
  defaultValue?: string | number;
  error: any;
  password?: boolean;
  email?: boolean;
  callback?: () => void;
  helpInfo?: string[];
  inputAccept?:
    | 'all'
    | 'eng'
    | 'eng-no-special'
    | 'jp'
    | 'jp-katakana'
    | 'jp-no-special-character'
    | 'number';
}

export default function TextAreaInput({
  control,
  inputName,
  placeholder = '',
  defaultValue,
  error,
  password = false,
  email = false,
  callback = () => {},
  helpInfo = [],
  rows = 4,
  inputAccept = 'all',
  ...props
}: Props) {
  const { t } = useTranslation();
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);
  return (
    <Controller
      control={control}
      name={inputName}
      defaultValue={defaultValue}
      render={({ field: { onChange, value, name } }) => (
        <div
          className={`custom-input ${props?.hidden ? 'hidden' : ''}`}
          style={{ height: '100px', position: 'relative' }}
        >
          <TextArea
            value={value}
            autoSize={{ minRows: rows, maxRows: rows }}
            onChange={v => {
              if (validateInput(v.target.value, inputAccept)) {
                onChange(v.target.value.trimStart());
                callback();
              } else {
                if (value === undefined) {
                  onChange('');
                }
              }
            }}
            className={error?.message ? 'error-input' : ''}
            placeholder={placeholder}
            name={name}
            autoComplete={'new-password'}
            {...props}
            style={{ paddingRight: '25px' }}
          />
          <div style={{ position: 'absolute', top: 7, right: 7 }}>
            <Tooltip
              title={
                error?.message ? (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t(error?.message),
                    }}
                  />
                ) : (
                  <HelpInfo helpInfo={helpInfo} />
                )
              }
              overlayClassName={
                error?.message ? 'error-tooltip' : 'help-tooltip'
              }
              placement="topRight"
              color={''}
              arrowPointAtCenter
              trigger={
                window.matchMedia('(any-pointer: coarse)').matches
                  ? 'click'
                  : 'hover'
              }
            >
              <div style={{ display: 'flex' }} ref={hoverRef}>
                {error?.message ? (
                  <InfoCircleIcon />
                ) : helpInfo.length > 0 ? (
                  <InfoCircleIcon type="help" isHover={isHover} />
                ) : null}
              </div>
            </Tooltip>
          </div>
        </div>
      )}
    />
  );
}
